<template>
  <div class="design-thermal">
    <span>R-{{ item.extraData.rValue.name }}</span> /
    <span
      v-for="(description, key, index) in item.extraData.descriptions"
      :key="key"
    >
      {{description}}<span
        v-if="index + 1 != Object.keys(item.extraData.descriptions).length">, </span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'design-thermal',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/designReport/DesignThermal.vue